module.exports = __webpack_public_path__ + "static/media/image2_large.38bf115a.jpg";